import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ReviewApplicationPage } from "@/features/user/application-page";
import { userPointsQueryOptions } from "@/lib/client/user";

export const Route = createFileRoute("/_index/_authed/application")({
  staticData: {
    title: "申请复盘",
  },
  component: RouteComponent,
  loader(ctx) {
    return ctx.context.queryClient.ensureQueryData(userPointsQueryOptions);
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { user } = Route.useRouteContext();

  return (
    <ReviewApplicationPage currentUser={user} onSuccess={() => navigate({ to: "/history" })} />
  );
}
